import { ColumnVehicleDistributionDto } from "@/dtos";
import { CreateDispatchItineraryDto, FormDispatchItineraryDto } from "@/dtos";
import { VehicleDistribution } from "@/entities";

export const formatColumnDispatchItineraryDto = async (dispatch: VehicleDistribution[]): Promise<ColumnVehicleDistributionDto[]> => {
    const result = [] as ColumnVehicleDistributionDto[];
    dispatch.map((x) => {
        const tableDispatchDto: ColumnVehicleDistributionDto = {
            name: (x.id_route_group) ? x.id_route_group.toString() : '0',
            label: (x.extra?.groupRoute) ? x.extra?.groupRoute : '',
            field: (x.id_route_group) ? x.id_route_group.toString() : '0',
            align: 'left',
        }
        result.push(tableDispatchDto);
    });
    return result;
}

export const formatRowDispatchItineraryDto = async (dispatch: VehicleDistribution[]): Promise<[]> => {
    const result = [] as any;
    dispatch.map((x) => {
        result.push({ [x.id_route_group]: x.extra?.vehicle + " " + x.name });
    });
    return result;
}

export const formatDispatchItineraryDto = async (formDispatchItinerary: FormDispatchItineraryDto, adminId: number, isCreate: boolean) => {
    const deviceDto = {
        company_id: formDispatchItinerary.company_id,
        vehicle_group_id: formDispatchItinerary.vehicle_group_id,
        route_group_id: formDispatchItinerary.vehicle_group_id,
        date:  formDispatchItinerary.date,
        created_by: (isCreate) ? adminId : undefined,  
    }

    return  deviceDto as CreateDispatchItineraryDto  
}